import React, { useState, useEffect } from 'react';

const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789!@#$%^&*';

function handleShuffle(e) {
  const spans = e.currentTarget.querySelectorAll('[data-hover-shuffle-child]');
  spans.forEach((span, idx) => {
    const original = span.getAttribute('data-original');
    const randomChar = chars[Math.floor(Math.random() * chars.length)];
    span.textContent = randomChar;
    // 강력한 3D 트랜스폼
    const rotateY = (Math.random() - 0.5) * 360; // -180~+180deg
    const rotateX = (Math.random() - 0.5) * 180; // -90~+90deg
    const translateY = (Math.random() - 0.5) * 24; // -12~+12px
    span.style.transform = `rotateY(${rotateY}deg) rotateX(${rotateX}deg) translateY(${translateY}px) scale(1.3)`;
    span.style.color = '#6B46C1'; // primary 컬러 강조
    // 부드럽게 복원 (글자별 딜레이)
    setTimeout(() => {
      span.textContent = original === ' ' ? '\u00A0' : original;
      span.style.transform = '';
      span.style.color = '';
    }, 400 + idx * 20);
  });
}

function resetShuffle(e) {
  const spans = e.currentTarget.querySelectorAll('[data-hover-shuffle-child]');
  spans.forEach(span => {
    const original = span.getAttribute('data-original');
    span.textContent = original === ' ' ? '\u00A0' : original;
    span.style.transform = '';
    span.style.color = '';
  });
}

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isServiceDropdownOpen, setIsServiceDropdownOpen] = useState(false);
  const [isServiceSubOpen, setIsServiceSubOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 10) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // 서비스 서브메뉴 항목
  const serviceSubItems = [
    { href: '#services', label: 'AI 솔루션' },
    { href: '#subscription', label: '구독 서비스' },
    { href: '#education', label: 'AI 교육' },
  ];

  // 메뉴 항목 배열 (한글)
  const menuItems = [
    { href: '#about', label: 'FIRM' },
    { href: '#services', label: '서비스', hasDropdown: true },
    { href: '#portfolio', label: '포트폴리오' },
    { href: '#team', label: '팀' },
    { href: '#contact', label: '문의하기' },
  ];

  return (
    <header 
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white shadow-md py-2' : 'bg-transparent py-4'
      }`}
    >
      <div className="container mx-auto px-4 flex justify-between items-center">
        {/* 로고 */}
        <a href="#" className="flex items-center">
          <img src="/image/logo.png" alt="GenAI Dev" className="h-10" />
        </a>

        {/* 데스크탑 메뉴 */}
        <nav className="hidden md:flex space-x-8 items-center">
          {menuItems.map(item => {
            if (item.hasDropdown) {
              return (
                <div
                  key={item.href}
                  className="relative"
                  onMouseEnter={() => setIsServiceDropdownOpen(true)}
                  onMouseLeave={() => setIsServiceDropdownOpen(false)}
                >
                  <button
                    className="text-dark hover:text-primary transition-colors menu-link border-b-2 border-transparent hover:border-primary px-1 pb-1 flex items-center gap-1"
                  >
                    {item.label}
                    <svg
                      className={`w-4 h-4 transition-transform ${isServiceDropdownOpen ? 'rotate-180' : ''}`}
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                    </svg>
                  </button>
                  {isServiceDropdownOpen && (
                    <div className="absolute top-full left-0 mt-2 w-48 bg-white shadow-lg rounded-lg py-2 z-50">
                      {serviceSubItems.map(sub => (
                        <a
                          key={sub.href}
                          href={sub.href}
                          className="block px-4 py-2 text-dark hover:bg-primary/10 hover:text-primary transition-colors"
                        >
                          {sub.label}
                        </a>
                      ))}
                    </div>
                  )}
                </div>
              );
            }
            return (
              <a
                key={item.href}
                href={item.href}
                className="text-dark hover:text-primary transition-colors menu-link border-b-2 border-transparent hover:border-primary px-1 pb-1"
              >
                {item.label}
              </a>
            );
          })}
          <a
            href="#contact"
            className="bg-primary text-white px-4 py-2 rounded-md hover:bg-primary/80 transition-colors menu-link"
          >
            Demo Request
          </a>
        </nav>

        {/* 모바일 메뉴 버튼 */}
        <div className="md:hidden">
          <button 
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="text-dark focus:outline-none"
          >
            <svg 
              xmlns="http://www.w3.org/2000/svg" 
              className="h-6 w-6" 
              fill="none" 
              viewBox="0 0 24 24" 
              stroke="currentColor"
            >
              {isMobileMenuOpen ? (
                <path 
                  strokeLinecap="round" 
                  strokeLinejoin="round" 
                  strokeWidth={2} 
                  d="M6 18L18 6M6 6l12 12" 
                />
              ) : (
                <path 
                  strokeLinecap="round" 
                  strokeLinejoin="round" 
                  strokeWidth={2} 
                  d="M4 6h16M4 12h16M4 18h16" 
                />
              )}
            </svg>
          </button>
        </div>
      </div>

      {/* 모바일 메뉴 */}
      {isMobileMenuOpen && (
        <nav className="md:hidden bg-white shadow-lg absolute top-full left-0 w-full py-4 px-4 flex flex-col space-y-4">
          {menuItems.map(item => {
            if (item.hasDropdown) {
              return (
                <div key={item.href}>
                  <button
                    className="text-dark hover:text-primary transition-colors menu-link border-b-2 border-transparent hover:border-primary px-1 pb-1 flex items-center justify-between w-full"
                    onClick={() => setIsServiceSubOpen(!isServiceSubOpen)}
                  >
                    {item.label}
                    <svg
                      className={`w-4 h-4 transition-transform ${isServiceSubOpen ? 'rotate-180' : ''}`}
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                    </svg>
                  </button>
                  {isServiceSubOpen && (
                    <div className="pl-4 mt-2 flex flex-col space-y-2">
                      {serviceSubItems.map(sub => (
                        <a
                          key={sub.href}
                          href={sub.href}
                          className="text-dark hover:bg-primary/10 hover:text-primary transition-colors px-2 py-1 rounded"
                          onClick={() => {
                            setIsMobileMenuOpen(false);
                            setIsServiceSubOpen(false);
                          }}
                        >
                          {sub.label}
                        </a>
                      ))}
                    </div>
                  )}
                </div>
              );
            }
            return (
              <a
                key={item.href}
                href={item.href}
                className="text-dark hover:text-primary transition-colors menu-link border-b-2 border-transparent hover:border-primary px-1 pb-1"
                onClick={() => setIsMobileMenuOpen(false)}
              >
                {item.label}
              </a>
            );
          })}
          <a
            href="#contact"
            className="bg-primary text-white px-4 py-2 rounded-md hover:bg-primary/80 transition-colors text-center menu-link"
            onClick={() => setIsMobileMenuOpen(false)}
          >
            Demo Request
          </a>
        </nav>
      )}
    </header>
  );
};

export default Header; 